
<template>
  <div cy-id="music-tracks">
    <v-row>
      <v-col>
        <v-btn
          class="mr-2"
          dark
          color="green"
          @click="load"
          cy-id="btn-tracks-load"
        >
          <v-icon v-if="campaignIsLoadingTracksReload">mdi-timer-sand</v-icon>
          Reload
        </v-btn>
        <span>Reloading tracks can take some time</span>
      </v-col>
      <v-col>
        <p>Last reload: {{ lastReloadAt?.toLocaleString() || 'never' }}</p>
        <p v-if="campaignTracksLastReload?.error">Error: {{ campaignTracksLastReload.error }}</p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-data-table
          class="mt-2"
          :headers="headers"
          :loading="campaignIsLoadingTracksGet"
          :items="campaignTracks"
          :items-per-page="15"
        ></v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import { RestTrack, TracksReloadJobState } from '@/types'
import { Component, Vue } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'

@Component
export default class BuilderMusicTracks extends Vue {
  @Action('LOAD_TRACKS') loadTracks!: (loadJobState: boolean) => Promise<void>
  @Action('RELOAD_TRACKS') reloadTracks!: () => Promise<void>

  @Getter campaignIsLoadingTracksGet!: boolean
  @Getter campaignIsLoadingTracksReload!: boolean
  @Getter campaignTracks!: RestTrack[]
  @Getter campaignTracksLastReload!: TracksReloadJobState|null

  headers: any[] = [
    { text: 'ID', value: 'id', sortable: true },
    { text: 'Name', value: 'name', sortable: true },
    { text: 'Artist', value: 'artist_name' },
    { text: 'Spotify', value: 'spotify_id', sortable: false },
  ]

  get lastReloadAt (): Date|null {
    if (!this.campaignTracksLastReload) {
      return null
    }
    return this.campaignTracksLastReload.completed_at ? new Date(this.campaignTracksLastReload.completed_at) : null
  }

  created () {
    this.loadTracks(true)
  }

  async load () {
    this.reloadTracks()
    await this.loadTracks(true)
  }
}
</script>

<style scoped></style>
